import React, { useState } from "react";
import Tilt from "react-parallax-tilt";
import { QRCodeSVG } from "qrcode.react";
import logo from "./3.png";
import logo1 from "./1.png";
import logo2 from "./2.png";
import logo3 from "./logo.png";


const DigitalPlatinumCard = () => {
  const [flipped, setFlipped] = useState(false);

  return (
    <div className="card-container pt-5">
      <Tilt
        glareEnable={true}
        glareMaxOpacity={0.25}
        scale={1.05}
        tiltMaxAngleX={10}
        tiltMaxAngleY={10}
      >
        <div className={`platinum-card ${flipped ? "flipped" : ""}`}>
          {/* Front Side */}
          {/* Front Side */}
          <div className="card-face card-front p-4">
            {/* Company Name */}
            <div className="d-flex justify-content-between"> <div className="company-header text-center">
              <h5 className="brand-title mb-2">   Spring Concept India Pvt. Ltd.  </h5>
              <div className="brand-divider"></div>
            </div>  </div>
           

            {/* Center Logo */}
            <div className="logo-wrapper"> 
              <div className="logo-circle big">
                <img src={logo3} alt="Company Logo" /> 
              </div>
            </div>

            {/* User Info */}
            <div className="user-info text-center mt-3">
              <h5 className="card-name mb-1"> Sanjeet Chahar</h5>
              <p className="card-role mb-1">Managing Director </p>
              <p className="card-phone mb-2">+91-9711256623</p>
             

            </div>

            {/* QR + Contact */}
            <div className="qr-section d-flex justify-content-between align-items-end">
              <div className="small-details">
                <p className=" mb-1"> <i className="fa fa-envelope  me-2"></i>md.scipl@gmail.com</p>
               
              </div>

              <QRCodeSVG
                value={`BEGIN:VCARD
VERSION:3.0
N:Sanjeet Chahar
TEL:+919711256623
EMAIL:md.scipl@gmail.com
END:VCARD`}
                size={60}
                fgColor="#000"
              />
            </div>
          </div>

          {/* Back Side */}
          <div className="card-face card-back p-4">
           <div className="company-header text-center">
              <h5 className="brand-title mb-2">  Spring Concept India Pvt. Ltd.   </h5>
              <div className="brand-divider"></div>
            </div>
            {/* Center Logo */}
            {/* <div className="logo-wrapper">
              <div className="logo-circle big">
                <img src={logo} alt="Company Logo" />
              </div>
            </div> */}

            <p className="address text-start large text-muted">
              <h5 className="text-center text-dark">Contact Details:</h5>
              <div className="brand-divider "></div>
              <div className="pt-2">
                {" "}
                <i className="fa fa-map me-2"></i>N-26,Sector -3, DSIIDC Industrial area, Bawana, Delhi-110039
                <p className=" mb-1"><i className="fa fa-envelope  me-2"></i>  md.scipl@gmail.com</p>
                
              </div>
            </p>
            <div className="qr-box " style={{top:'30%'}}>
              <QRCodeSVG
                value="https://maps.app.goo.gl/5k2awunUsZ671dhu7"
                size={100}
                fgColor="#000000" 
              />
            </div>
          </div>
        </div>
      </Tilt>

      {/* Manual flip button */}
      <button
        className="platinum-btn mt-4 rounded-pill"
        onClick={() => setFlipped(!flipped)}
      >
        {flipped ? "Show Front" : "Show Back"}
      </button>

      {/* Action buttons */}
      <div
        className="d-flex flex-column gap-3 mt-5 w-75 mx-auto"
        style={{ maxWidth: "280px" }}
      >
        <a href="/sachin.vcf" download className="platinum-btn">
          Add To Contacts
        </a>
        <a href="tel:+919711256623" className="platinum-btn">
          Call Now
        </a>
        <a href="mailto:md.scipl@gmail.com" className="platinum-btn">
          Email Us
        </a>
        <a
          href="https://wa.me/+919711256623"
          target="_blank"
          className="platinum-btn"
        >
          WhatsApp
        </a>

        <a
          href="https://www.springconcept.co.in/"
          target="_blank"
          rel="noopener noreferrer"
          className="platinum-btn"
        >
          Website
        </a>
        <a
          href="https://maps.app.goo.gl/5k2awunUsZ671dhu7"
          target="_blank"
          rel="noopener noreferrer"
          className="platinum-btn"
        >
          Address Details
        </a>
        <a href="/brochure.pdf" download className="platinum-btn">
          Brochure
        </a>
      </div>
    </div>
  );
};

export default DigitalPlatinumCard;
